const c = {
  name: "Hands11100",
  dimensions: { width: 35, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 35 40" style="enable-background:new 0 0 35 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M22,40c-4.7,0-9.3-2-12.4-5.6l-6.7-7.5l-1.9-2.3c-1.4-1.7-1.2-4.2,0.5-5.6c1.7-1.4,4.2-1.2,5.6,0.5l2,2.1V6
			c0-2.2,1.8-4,4-4c0.8,0,1.6,0.2,2.2,0.7C15.8,1.1,17.3,0,19,0c2.2,0,4,1.8,4,4v8.5c0.6-0.3,1.3-0.5,2-0.5c1.7,0,3.2,1.1,3.8,2.7
			c0.6-0.4,1.4-0.7,2.2-0.7c2.2,0,4,1.8,4,4v9C35,34.2,29.2,40,22,40z M17,4v17h4V4c0-1.1-0.9-2-2-2C17.9,2,17,2.9,17,4z M15,21V6
			c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v20.5l-5.4-5.7l0,0c-0.7-0.9-2-1-2.8-0.2c-0.9,0.7-1,2-0.2,2.8l1.9,2.3l6.7,7.5
			C13.9,36.2,17.8,38,22,38c6.1,0,11-4.9,11-11v-2.5c-0.6,0.3-1.3,0.5-2,0.5c-0.8,0-1.6-0.2-2.2-0.7c-0.5,1.6-2,2.7-3.8,2.7
			c-2.2,0-4-1.8-4-4h-8v-2H15z M33,21L33,21v-3c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2v3c0,1.1,0.9,2,2,2C32.1,23,33,22.1,33,21z M23,23
			c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2v-7c0-1.1-0.9-2-2-2c-1.1,0-2,0.9-2,2V23z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as Hands11100
};
